var App = App || {};

App.Login = (function ($) {
    "use strict";

    function Interaction() {

        const offcanvas = $("#LoginOffcanvas");
        offcanvas.on("shown.bs.offcanvas", function () { $(this).find("input").first().trigger("focus"); });
        offcanvas.on("hidden.bs.offcanvas", function () { $(this).find("input").val(""); });

        const MobileLogin = $("#LoginDropdown");
        const MobileLoginFocusable = [$(".site-header-login-trigger"), MobileLogin];
        MobileLogin
            .on("shown:zag:mobiledropown", function () {
                App.Base.FocusTrap(MobileLogin, MobileLoginFocusable, false);
            })
            .on("hidden:zag:mobiledropown", function () {
                $(this).find("input").val("");
                App.Base.FocusTrap(MobileLogin, MobileLoginFocusable, true);
            });
    }

    return {
        Interaction: Interaction
    };

})(jQuery);

$(function () {
    App.Login.Interaction();
});